import React from "react";
import styles from "./connecting.module.scss";
import { Content, Screen } from "../screen/Screen";
import { Spinner } from "../spinner/Spinner";

type ConnectingProps = { displayTitle?: string };

/**
 * Connecting message display with spinner
 * @param {string} [props.displayTitle]
 * @returns {JSX.Element}
 */
export const Connecting: React.FC<ConnectingProps> = ({ displayTitle = 'Connecting...' }) => {
  return (
    <Screen>
      <Content>
        <div className={styles.connecting}>{displayTitle}</div>
        <Spinner cssClass={styles.spinner} />
      </Content>
    </Screen>
  );
};